export enum ProjectListViewMode {
  LIST = 'list',
  GRID = 'grid',
}
